import { takeLatest } from 'redux-saga/effects';
import {
	getRegisteredUsersChartSuccess, getRegisteredUsersChartFail,
	getRegisteredAnimalsChartSuccess, getRegisteredAnimalsChartFail,
	getAnimalsStatusChartSuccess, getAnimalsStatusChartFail,
	getWidgetDataSuccess, getWidgetDataFail,
	getTopFarmersSuccess, getTopFarmersFail,
} from './dashboardState';
import createCrudService from '../../services/crudservice';
import { doCrudCall } from '../../utils/crudSagaHelper';

const dashboardService = createCrudService('api/v1/admin/dashboard');

function* getRegisteredUsersChart(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`graphs/registered-users`, data.payload), 
		getRegisteredUsersChartSuccess, 
		getRegisteredUsersChartFail);
}

function* getRegisteredAnimalsChart(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`graphs/registered-animals`, data.payload), 
		getRegisteredAnimalsChartSuccess, 
		getRegisteredAnimalsChartFail);
}

function* getAnimalsStatusChart(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`graphs/animals-status`, data.payload), 
		getAnimalsStatusChartSuccess, 
		getAnimalsStatusChartFail);
}

function* getWidgetData(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`widgets/all`, data.payload), 
		getWidgetDataSuccess, 
		getWidgetDataFail);
}

function* getTopFarmers(data) {	
	yield doCrudCall(
		() => dashboardService.doGetRequest(`tables/top-farmers`, data.payload), 
		getTopFarmersSuccess, 
		getTopFarmersFail);
}

function* dashboardSaga() {
	yield takeLatest('dashboard/getRegisteredUsersChart', getRegisteredUsersChart);
  yield takeLatest('dashboard/getRegisteredAnimalsChart', getRegisteredAnimalsChart);
  yield takeLatest('dashboard/getAnimalsStatusChart', getAnimalsStatusChart);
  yield takeLatest('dashboard/getWidgetData', getWidgetData);
  yield takeLatest('dashboard/getTopFarmers', getTopFarmers);
}

export default dashboardSaga;
